module.exports = "/shiftTasks/components/taskTemplates/taskTemplateLookupItem-20a7e1.html";